import { Component, Input, inject } from "@angular/core"
import { MatDialog } from "@angular/material/dialog"
import { MatIcon } from "@angular/material/icon"
import { MatTooltip } from "@angular/material/tooltip"
import { Geolocation } from "../../models"
import { MapDialogComponent } from "./map-dialog.component"

@Component({
    selector: "valben-map-modal",
    standalone: true,
    template: `
        <button
            type="button"
            class="valben-row-action"
            [attr.aria-label]="tooltip"
            [matTooltip]="tooltip"
            (click)="open()">
            <mat-icon>{{ icon }}</mat-icon>
        </button>`,
    imports: [MatIcon, MatTooltip],
})
export class MapModalComponent {
    @Input() data!: Geolocation
    @Input() icon: string = "place"
    @Input() tooltip: string = "Detalji"

    private readonly _dialog = inject(MatDialog)

    open(): void {
        this._dialog.open(MapDialogComponent, {
            data: this.data,
            width: "60vw",
        })
    }
}
